module.exports = __webpack_public_path__ + "img/41.0b009f7b.gif";